import { FC, JSX, useEffect, useState } from "react";
import "./AgentsCategories.scss";
import MasterPage from "../../../pages/MasterPage/MasterPage";
import PageBase from "../../../components/PageBase/PageBase";
import SkeletonTable from "../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightArrowLeft,
  faCircleCheck,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePaginate } from "../../../providers/PaginateProvider";
import ModalAgentsCategoriesInsert from "../../../components/Agents/AgentsCategories/ModalAgentsCategoriesInsert/ModalAgentsCategoriesInsert";
import ModalAgentsCategoriesLinkFinancials from "../../../components/Agents/AgentsCategories/ModalAgentsCategoriesLinkFinancials/ModalAgentsCategoriesLinkFinancials";
import { useAgentsCategories } from "../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";
import { AgentsCategoryModel } from "../../../models/Agents/AgentsCategory/AgentsCategoryModel";
import moment from "moment";
import SidebarAgentsCategoriesFilter from "../../../components/Agents/AgentsCategories/SidebarAgentsCategoriesFilter/SidebarAgentsCategoriesFilter";
import { useSidebarFilter } from "../../../providers/SidebarFilterProvider";

interface AgentsCategoriesProps { }

const AgentsCategories: FC<AgentsCategoriesProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const [showModalLinkFinancials, setShowModalLinkFinancials] =
    useState<boolean>(false);
  const [categoryLinkFinancials, setCategoryLinkFinancials] =
    useState<AgentsCategoryModel | null>(null);

  const {
    pages,
    params,
    setParams,
    isLoading,
    error,
    categories,
    setCategory,
    handleList,
    handleDelete,
    setIsLoading,
    handleReactivate,
  } = useAgentsCategories();
  const { handlePaginate } = usePaginate();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();

  useEffect(() => {
    handleList();
  }, []);

  const handleEdit = (item: AgentsCategoryModel) => {
    setCategory(item);
    setShowModalInsert(true);
  };

  const handleCloseModal = () => {
    setShowModalInsert(false);
    setCategory(null);
  };

  const handleLinkFinancials = (item: AgentsCategoryModel) => {
    setCategoryLinkFinancials(item);
    setShowModalLinkFinancials(true);
  };

  const handleCloseModalLinkFinancials = () => {
    setShowModalLinkFinancials(false);
    setCategoryLinkFinancials(null);
  };

  const handleDeleteAgentsCategories = (item: AgentsCategoryModel) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir a categoria ${item?.name}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDelete(item.id || 0).then();
        if (ret) {
          toast.success("Categoria inativada com sucesso!");
          handleList();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar a categoria.<br>${error}`,
            "error"
          );
        }
      }
    });
  };

  const handleReactivateItem = async (itemId: number) => {
    if (itemId <= 0) return;

    const ret = await handleReactivate(itemId);

    if (ret) {
      toast.success("Categoria reativada com sucesso!");
      handleList();
    }
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {categories?.length > 0 ? (
          <>
            {categories.map((x: AgentsCategoryModel, key: number) => (
              <tr key={x.id} className="text-sm">
                <td className="text-center">{x.id}</td>
                <td className="text-wrap col-medium">{x?.name}</td>
                <td className="text-wrap">{x?.description}</td>
                <td className="text-center">{x?.model_name}</td>
                <td className="text-center">
                  {x?.questions ? x?.questions?.length : 0}
                </td>
                <td className="text-center">
                  {moment(x?.created_at).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="text-center">
                  <span
                    className={
                      x?.deleted_at ? "badge bg-danger" : "badge bg-success"
                    }
                  >
                    {x?.deleted_at ? "Inativo" : "Ativo"}
                  </span>
                </td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    {!x?.deleted_at && (
                      <>
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleEdit(x)}
                        >
                          <FontAwesomeIcon icon={faEdit} className="me-2" />{" "}
                          Editar
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleDeleteAgentsCategories(x)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                          Remover
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleLinkFinancials(x)}
                        >
                          <FontAwesomeIcon
                            icon={faArrowRightArrowLeft}
                            className="me-2"
                          />{" "}
                          Vincular Financeiras
                        </Dropdown.Item>
                      </>
                    )}
                    {x?.deleted_at && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleReactivateItem(x?.id ?? 0)}
                      >
                        <FontAwesomeIcon
                          icon={faCircleCheck}
                          className="me-2"
                        />
                        Reativar
                      </Dropdown.Item>
                    )}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={8} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7 col-medium" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7 w-25" scope="col">
                      Descrição
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Modelo
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Qtde Questões
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data de Cadastro
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {categories?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    setParams({ ...params, page: 1, filter: { only_active: false } });
  }, []);

  return (
    <MasterPage title="Categorias de Artigos" icon="fas fa-file" footerFixed>
      <div className="AgentsCategories" data-testid="AgentsCategories">
        <PageBase
          title="Categorias de Artigos"
          subtitle="Gerenciamento de Categorias de Artigos"
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          hasFilter
          useButtonGroup
        >
          {renderContent()}
        </PageBase>

        <ModalAgentsCategoriesInsert
          show={showModalInsert}
          onClose={() => handleCloseModal()}
        />

        <ModalAgentsCategoriesLinkFinancials
          show={showModalLinkFinancials}
          category={categoryLinkFinancials}
          onClose={() => handleCloseModalLinkFinancials()}
        />
      </div>

      <SidebarAgentsCategoriesFilter />
    </MasterPage>
  );
};

export default AgentsCategories;
